import type { FC } from 'react';

import { Typography } from '@mui/material';

type RecommendedLengthHintProps = {
  length: number;
  recommendedLength?: number;
  maxLength?: number;
};

export const RecommendedLengthHint: FC<RecommendedLengthHintProps> = ({ length, recommendedLength, maxLength }) => {
  if (maxLength && length > maxLength) {
    return (
      <Typography className="text-red-main" variant="caption">
        {length - maxLength} characters over the maximum length ({maxLength} characters)
      </Typography>
    );
  }

  if (recommendedLength && length > recommendedLength) {
    return (
      <Typography className="text-orange-text-dark" variant="caption">
        {length - recommendedLength} characters over the recommended length for mobile ({recommendedLength} characters)
      </Typography>
    );
  }

  return null;
};
